/**
 * @author Jersson Morales
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useMediaQuery, useTheme } from '@material-ui/core';
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import { manejadorDialogoGlobal } from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IEtapas from 'Infotrack@Modelos/smartStock/etapas/entidades/etapas';
import IFlujos from 'Infotrack@Modelos/smartStock/flujos/entidades/flujos';
import IFlujosEtapas from 'Infotrack@Modelos/smartStock/flujosEtapas/entidades/flujosEtapas';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import EntidadesFlujosEtapasCM from '../controladorModelo/entidadesFlujosEtapasCM';
import FlujosEtapasCM from '../controladorModelo/flujosEtapasCM';
import { acciones, IEstadoAPropiedades, IEstadoFlujosEtapas, IInputsFlujosEtapas } from '../interfaces';
import FormularioFlujosEtapasVista from '../vista/formularioFlujosEtapasVista';
import { useSelector } from 'react-redux';

const estadoInicial: IInputsFlujosEtapas = {
    EmpresaId: '',
    Flujo: null,
    EtapaActual: null,
    EtapaSiguiente: null,
    Estado: true,
    Entrada: true,
    Salida: true,
};
const flujosEtapasCM = new FlujosEtapasCM();
const entidadesFlujosEtapasCM = new EntidadesFlujosEtapasCM();

const FormularioFlujosEtapasCV: React.FunctionComponent<IEstadoAPropiedades> = ({ EmpresaId }) => {
    const idAgencia = useSelector((estado: IEstadoGlobal) => estado.estadoAutenticacion.agenciaActual!.IdAgencia);
    const [{ estadoFormulario, tipoFormulario, entidadFlujosEtapas }, dispatch] = useProveedor<IEstadoFlujosEtapas>();

    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IInputsFlujosEtapas>(estadoInicial);

    const [entidadesFlujosEtapas, setEntidadesFlujosEtapas] = React.useState<{
        flujoss: IFlujos[];
        etapass: IEtapas[];
    }>({ flujoss: [], etapass: [] });

    const theme = useTheme();
    const esMovil = useMediaQuery(theme.breakpoints.down('sm'));

    React.useEffect(() => {
        consultarEntidadesFlujosEtapas();
    }, []);

    React.useEffect(() => {
        if (entidadFlujosEtapas && tipoFormulario !== TipoFormulario.Creacion) {
            const flujo = entidadesFlujosEtapas.flujoss.find(({ FlujoId }) => FlujoId === entidadFlujosEtapas.FlujoId);
            const etapaActual = entidadesFlujosEtapas.etapass.find(
                ({ EtapaId }) => EtapaId === entidadFlujosEtapas.EtapaActual
            );
            const etapaSiguiente = entidadesFlujosEtapas.etapass.find(
                ({ EtapaId }) => EtapaId === entidadFlujosEtapas.EtapaSiguiente
            );
            setValor({
                ...(entidadFlujosEtapas as any),
                Flujo: flujo || null,
                EtapaActual: etapaActual || null,
                EtapaSiguiente: etapaSiguiente || null,
            });
        } else reiniciar();
    }, [entidadFlujosEtapas]);

    const consultarEntidadesFlujosEtapas = async () => {
        entidadesFlujosEtapasCM.consultarListaEntidadesFlujosEtapas().then((respuesta) => {
            /*setEntidadesFlujosEtapas({
                etapass: respuesta.etapass.filter((x) => x.Estado === 1),
                flujoss: respuesta.flujoss.filter((x) => x.Estado === true),
            });*/
        });
    };

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };

    const confirmarCreacionEdicionFlujosEtapas = () => {
        if (flujosEtapasCM.validarEntidad(mapearFlujosEtapas(valor))) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarFlujosEtapas,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarFlujosEtapas = () => {
        manejadorDialogoGlobal({ estado: false });
        if (tipoFormulario === TipoFormulario.Creacion) {
            flujosEtapasCM.crearFlujosEtapas(mapearFlujosEtapas(valor)).then((resultado) => {
                if (resultado.data.Resultado) {
                    cerrarFormulario();
                    dispatch({ type: acciones.RECARGAR_TABLA });
                }
            });
        } else {
            flujosEtapasCM.editarFlujosEtapas(mapearFlujosEtapas(valor)).then((resultado) => {
                if (resultado.data.Resultado) {
                    cerrarFormulario();
                    dispatch({ type: acciones.RECARGAR_TABLA });
                }
            });
        }
    };

    const alCambiarValorAutoComplete = (
        nuevoValor: IInputsFlujosEtapas[keyof IInputsFlujosEtapas],
        nombreValor: string
    ) => {
        setValor((valorAnterior) => ({ ...valorAnterior, [nombreValor]: nuevoValor }));
    };

    const mapearFlujosEtapas = (flujosEtapas: IInputsFlujosEtapas): IFlujosEtapas => ({
        ...flujosEtapas,
        Estado: flujosEtapas.Estado ? 1 : 0,
        FlujoId: Number(flujosEtapas.Flujo ? flujosEtapas.Flujo.FlujoId : 0),
        EtapaActual: Number(flujosEtapas.EtapaActual ? flujosEtapas.EtapaActual.EtapaId : 0),
        EtapaSiguiente: Number(flujosEtapas.EtapaSiguiente ? flujosEtapas.EtapaSiguiente.EtapaId : 0),
        EmpresaId,
        AgenciaId: idAgencia,
    });

    return (
        <FormularioFlujosEtapasVista
            accionCrearEditar={confirmarCreacionEdicionFlujosEtapas}
            alCambiarValor={alCambiarValor}
            alCambiarValorAutoComplete={alCambiarValorAutoComplete}
            flujosEtapas={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
            entidadesFlujosEtapas={entidadesFlujosEtapas}
            esMovil={esMovil}
        />
    );
};

const estadoAPropiedades = ({ estadoAutenticacion: { usuarioInformacion } }: IEstadoGlobal): IEstadoAPropiedades => ({
    EmpresaId: usuarioInformacion!.IdEmpresa,
});

export default connect<IEstadoAPropiedades, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioFlujosEtapasCV);
